export default function useHelpers() {
  function resolvePath(object, name, defaultValue = null) {
    return name
      .split('.')
      .reduce((o, p) => o ? o[p] : defaultValue, object)
  }

  function setPath(object, name, value) {
    if (value === '') {
      value = null
    }

    return name
      .split('.')
      .reduce((o, p, i) => o[p] = name.split('.').length === ++i ? value : o[p] || {}, object)
  }

  return {
    resolvePath, setPath,
  }
}
